import React from "react";

import { ReactComponent as EmptyImg } from "../images/default-photo.svg";

export default class ImageError extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: false,
        };

        this.onError = this.onError.bind(this);
    }

    componentDidMount() {
        if (!this.props.src) {
            this.setState({ error: true });
        }
    }

    onError() {
        this.setState({ error: true });
    }

    render() {
        const { error } = this.state;
        const { width, height } = this.props;

        return error ? (
            <EmptyImg className="col red1 font" style={{ width: width, height: height }} />
        ) : (
            <img
                loading="lazy"
                draggable="false"
                {...this.props}
                onError={this.onError}
                alt=""
                style={{ width: width, height: height, objectFit: 'cover', borderRadius: '7px' }}
            />
        );
    }
}